import tochtApi from "../../../api/e-loket/tochtApi";
import assign from 'object-assign';
import * as messages from "../../../constants/ToastrConstants";
import { showToastrSuccess, showToastrError } from "../../../util/toastr.js";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";

export default class KalenderGoedkeurenPageHelper {
	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const params = context.props.match.params;
		const provincieId = params.provincieId ? params.provincieId : "null";

		ajaxActions.started();
		tochtApi.getTochtenInAfwachtingByOrganisator(provincieId)
			.then((response) => {
				ajaxActions.ended();
				this.processModel(response);
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	processModel(response) {
		const context = this.context;
		const loadLayout = context.props.loadLayout;
		const model = response.data;
		const titel = model.federatieNaam;

		loadLayout(titel);

		context.setState({
			model
		});
	}

	onChangeGoedkeuren(index, event) {
		const value = event.target.value;
		const model = this.context.state.model;

		model.tochten[index]["goedgekeurd"] = value;

		if (value === "true" || value === true || value === null || value === "null")
			model.tochten[index]["redenVanAfkeuringEdited"] = model.tochten[index]["redenVanAfkeuring"];

		this.context.setState({
			model
		});
	}

	onChangeRedenVanAfkeuring(tochtId, event) {
		const value = event.target.value;
		let model = this.context.state.model;
		let workingTochtModel = model.tochten.find(tocht => tocht.id == tochtId);

		workingTochtModel.redenVanAfkeuringEdited = value;

		this.context.setState({
			model
		});
	}

	onSave() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const redirector = this.redirector;
		let model = context.state.model;
		let errors = null;

		ajaxActions.started();
		tochtApi.updateTochtenInAfwachting(model)
			.then((response) => {
				ajaxActions.ended();
				if (response.statusText === "OK" && !response.data.hasValidationErrors && response.data.item.isStored === true) {
					redirector.goTo("/e-loket/federatieOverzicht");
					showToastrSuccess(messages.MESSAGE_SAVED);
				} else {
					errors = assign({}, response.data.validationResults);
					model = assign({}, response.data.item, {});
					showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
				}

				this.context.setState({
					errors,
					validationMessageType: response.data.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING,
					model,
					shouldScrollToFirstError: true
				});
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}
}
